import React from "react";

import { DropdownItem } from "@atlaskit/dropdown-menu";
import { Text } from "@atlaskit/primitives-next";

import { Option } from "./types";

interface FastshiftTableFilterDropdownItemProps<T extends string> {
    option: Option<T>;
    onClick: () => void;
    isSelected: boolean;
    customContent?: React.ReactNode;
}

export const FastshiftTableFilterDropdownItem = <T extends string>({
    option,
    onClick,
    isSelected,
    customContent
}: FastshiftTableFilterDropdownItemProps<T>) => {
    return (
        <DropdownItem onClick={onClick} isSelected={isSelected}>
            {customContent ?? <Text>{option.label}</Text>}
        </DropdownItem>
    );
};
